import { useTranslation } from 'react-i18next';
import { useIsSupportSession } from '../support-access/use-support-session';
import DeleteAccountForm from '../delete-account-form/delete-account-form';

/* eslint-disable-next-line */
export interface DeleteAccountSettingsProps {}

export function DeleteAccountSettings(props: DeleteAccountSettingsProps) {
  const { t } = useTranslation(['common']);
  const isSupportSession = useIsSupportSession();
  return (
    <div>
      <div>
        <h2 className="text-base font-semibold leading-7 text-light-primaryText dark:text-dark-primaryText">
          {t('Delete Account')}
        </h2>
        <p className="mt-1 text-sm leading-6 text-light-primaryText dark:text-dark-primaryText">
          {t('delete-account-text')}
        </p>
      </div>

      {isSupportSession ? (
        <p className="mt-6 text-sm text-light-primaryText dark:text-dark-primaryText">
          {t('not-available-in-support-session')}
        </p>
      ) : (
        <DeleteAccountForm />
      )}
    </div>
  );
}

export default DeleteAccountSettings;
